import { z } from 'zod'

/**
 * Reminder rules on collection date fields (bills due dates, renewals…).
 * Read by the daily collection-reminder scheduler; gated by the
 * COLLECTION_REMINDERS feature flag (on for personal spaces and, as a generic
 * capability, for work orgs).
 */

export const CollectionReminderModeEnum = z.enum([
  // fieldDefinition is a DATE field holding the (next) due date
  'DATE_FIELD',
  // fieldDefinition is a NUMBER field holding a 1-31 day; recurs monthly
  'DAY_OF_MONTH_FIELD',
])
export type CollectionReminderModeEnum = z.infer<
  typeof CollectionReminderModeEnum
>

export const CollectionReminderRecurrenceEnum = z.enum([
  'ONE_SHOT',
  'ANNUAL',
  'MONTHLY',
])
export type CollectionReminderRecurrenceEnum = z.infer<
  typeof CollectionReminderRecurrenceEnum
>

export const CollectionReminderRuleSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  collectionId: z.string().uuid(),
  mode: CollectionReminderModeEnum,
  fieldDefinitionId: z.string().uuid(),
  /** Days before the due date to notify (0 = on the day). */
  offsetDays: z.array(z.number().int().min(0).max(60)).min(1).max(5),
  /** Optional BOOLEAN field that suppresses reminders when true (autopay). */
  skipWhenBooleanFieldId: z.string().uuid().nullable().optional(),
  recurrence: CollectionReminderRecurrenceEnum,
  isActive: z.boolean().default(true),
  createdById: z.string().uuid().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type CollectionReminderRule = z.infer<typeof CollectionReminderRuleSchema>

export const CreateCollectionReminderRuleDtoSchema =
  CollectionReminderRuleSchema.omit({
    id: true,
    organizationId: true,
    collectionId: true,
    createdById: true,
    createdAt: true,
    updatedAt: true,
  })
export type CreateCollectionReminderRuleDto = z.infer<
  typeof CreateCollectionReminderRuleDtoSchema
>

export const UpdateCollectionReminderRuleDtoSchema =
  CreateCollectionReminderRuleDtoSchema.partial()
export type UpdateCollectionReminderRuleDto = z.infer<
  typeof UpdateCollectionReminderRuleDtoSchema
>
